/* eslint-disable no-mixed-operators */
import { reduce, get } from 'lodash';
import moment from 'moment';

export const easter = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const easterMonth = Math.floor((h + l - 7 * m + 114) / 31);
  const easterDay = ((h + l - 7 * m + 114) % 31) + 1;

  return new Date(year, easterMonth - 1, easterDay);
};

export const findNextWeekDay = (year, month, day, targetWDay) => {
  const date = new Date(year, month, day);
  date.setDate(date.getDate() + (((targetWDay - date.getDay()) + 7) % 7));
  return date;
};

export const bondadagur = year => findNextWeekDay(year, 0, 19, 5);

export const sumardagurinnFyrsti = year => findNextWeekDay(year, 3, 19, 4);

export const fridagurVerslunarmanna = year => findNextWeekDay(year, 7, 1, 1);

export const solstice = (year, season) => {
  const interval = 1000 * (56.5 + 47 * 60 + 5 * 3600 + 365 * 86400);

  const date = (season === 'winter')
    ? new Date(2016, 11, 21, 10, 44)
    : new Date(2016, 5, 20, 22, 34); // Default to 'summer'

  while (date.getFullYear() < year) {
    date.setTime(date.getTime() + interval);
  }

  while (date.getFullYear() > year) {
    date.setTime(date.getTime() - interval);
  }

  return date;
};

export const holidays = (year) => {
  const easterSunday = easter(year);
  const day = 86400000;

  const holidayArr = [
    {
      date: new Date(year, 0, 1),
      description: 'Nýársdagur',
      holiday: true,
    },
    {
      date: bondadagur(year),
      description: 'Bóndadagur',
      holiday: false,
    },
    {
      date: new Date(easterSunday.getTime() - (48 * day)),
      description: 'Bolludagur',
      holiday: false,
    },
    {
      date: new Date(easterSunday.getTime() - (47 * day)),
      description: 'Sprengidagur',
      holiday: false,
    },
    {
      date: new Date(easterSunday.getTime() - (46 * day)),
      description: 'Öskudagur',
      holiday: false,
    },
    {
      date: new Date(year, 1, 14),
      description: 'Valentínusardagur',
      holiday: false,
    },
    {
      date: new Date(bondadagur(year).getTime() + (30 * day)),
      description: 'Konudagur',
      holiday: false,
    },
    {
      date: new Date(easterSunday.getTime() - (3 * day)),
      description: 'Skírdagur',
      holiday: true,
    },
    {
      date: new Date(easterSunday.getTime() - (2 * day)),
      description: 'Föstudagurinn langi',
      holiday: true,
    },
    {
      date: easterSunday,
      description: 'Páskadagur',
      holiday: true,
    },
    {
      date: new Date(easterSunday.getTime() + day),
      description: 'Annar í páskum',
      holiday: true,
    },
    {
      date: sumardagurinnFyrsti(year),
      description: 'Sumardagurinn fyrsti',
      holiday: true,
    },
    {
      date: new Date(easterSunday.getTime() + (39 * day)),
      description: 'Uppstigningardagur',
      holiday: true,
    },
    {
      date: new Date(easterSunday.getTime() + (49 * day)),
      description: 'Hvítasunnudagur',
      holiday: true,
    },
    {
      date: new Date(easterSunday.getTime() + (50 * day)),
      description: 'Annar í Hvítasunnu',
      holiday: true,
    },
    {
      date: new Date(year, 4, 1),
      description: 'Verkalýðsdagurinn',
      holiday: true,
    },
    {
      date: new Date(year, 5, 17),
      description: 'Þjóðhátíðardagur Íslendinga',
      holiday: true,
    },
    {
      date: solstice(year, 'summer'),
      description: 'Sumarsólstöður',
      holiday: false,
    },
    {
      date: new Date(year, 5, 24),
      description: 'Jónsmessa',
      holiday: false,
    },
    {
      date: fridagurVerslunarmanna(year),
      description: 'Frídagur verslunarmanna',
      holiday: true,
    },
    {
      date: new Date(year, 9, 31),
      description: 'Hrekkjavaka',
      holiday: false,
    },
    {
      date: new Date(year, 11, 1),
      description: 'Fullveldisdagurinn',
      holiday: false,
    },
    {
      date: solstice(year, 'winter'),
      description: 'Vetrarsólstöður',
      holiday: false,
    },
    {
      date: new Date(year, 11, 23),
      description: 'Þorláksmessa',
      holiday: false,
    },
    {
      date: new Date(year, 11, 24),
      description: 'Aðfangadagur',
      holiday: true,
      halfDay: true,
    },
    {
      date: new Date(year, 11, 25),
      description: 'Jóladagur',
      holiday: true,
    },
    {
      date: new Date(year, 11, 26),
      description: 'Annar í Jólum',
      holiday: true,
    },
    {
      date: new Date(year, 11, 31),
      description: 'Gamlársdagur',
      holiday: true,
      halfDay: true,
    },
  ];

  return (reduce(holidayArr, (res, val) => {
    const d = moment(get(val, 'date')).format('DD-MM-YYYY').toString();
    return { ...res, [d]: { ...val } };
  }, {}));
};

export const isRedDay = (day) => {
  const h = holidays(day.getFullYear());
  const ds = moment(day).format('DD-MM-YYYY').toString();
  return Boolean(get(h, `[${ds}].holiday`));
};

export const isHalfDay = (day) => {
  const h = holidays(day.getFullYear());
  const ds = moment(day).format('DD-MM-YYYY');
  return Boolean(get(h, `[${ds}].halfDay`));
};
export const numberOfWorkingDays = (startDate, endDate) => {
  const currentDate = new Date(startDate);
  let dayCount = 0;
  while (currentDate <= endDate) {
    if (!isRedDay(currentDate) && currentDate.getDay() !== 6 && currentDate.getDay() !== 0) {
      dayCount += 1;
    } else if (isHalfDay(currentDate) && currentDate.getDay() !== 6 && currentDate.getDay() !== 0) {
      dayCount += 0.5;
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dayCount;
};

export const getNumberOfDays = (startDate, endDate, registerRedDays, registerWeekend) => {
  const currentDateIn = new Date(startDate);
  const currentDateOut = new Date(endDate);
  let numberOfDays = 0;
  while (currentDateIn <= new Date(endDate)) {
    const isWeekday = !isRedDay(currentDateIn) && currentDateIn.getDay() % 6 !== 0;
    if (isWeekday) {
      numberOfDays += 1;
    } else if (isHalfDay(currentDateIn)) {
      // do nothing for half days ?
    } else if (isRedDay(currentDateIn) && registerRedDays) {
      numberOfDays += 1;
    } else if ((currentDateIn.getDay() % 6 === 0) && registerWeekend) {
      numberOfDays += 1;
    }
    currentDateIn.setDate(currentDateIn.getDate() + 1);
    currentDateOut.setDate(currentDateOut.getDate() + 1);
  }
  return numberOfDays;
};



// WEBPACK FOOTER //
// ./src/sites/time/components/holidays.js